import clsx from 'clsx'

const MessageSkeltonBox = ({ isSender }: { isSender?: boolean }) => {
    return (
        <div className={clsx("animate-pulse w-full flex flex-col items-start mb-3", isSender && "items-end")}>
            <div className={clsx("max-w-[80%] w-[40%] h-[50px] bg-overlay-mid border border-edge-faint rounded-sm inline-block", isSender && "!bg-surface-elevated")}>
            </div>
        </div>
    )
}

export default MessageSkeltonBox
